import cx from 'classnames'
import PropTypes from 'prop-types'

import Injector from '@s-ui/react-primitive-injector'
import PolymorphicElement from '@s-ui/react-primitive-polymorphic-element'

import ItemBasicContent from './components/Content/index.js'
import {BASE_CLASS, CHECK_ELEMENT_TYPES, DESIGNS, DIRECTIONS, getWrapperProps, NO_OP} from './config.js'

const FilterItemBasic = ({
  attributes,
  checkElementType = CHECK_ELEMENT_TYPES.NONE,
  description,
  design,
  direction,
  element,
  extendedInfo,
  hasIconCheck = true,
  helpText,
  icon,
  id,
  imageSrc,
  isBolder,
  isDisabled = false,
  isFullWidth,
  isHighlighted = false,
  isIndeterminate,
  isLeftIcon,
  isSelected,
  label,
  onChange = NO_OP,
  paddingLess = false,
  rightIcon,
  showCheckOnSelected = true,
  tabIndex
}) => {
  const handleChange = () => onChange({id, label})

  const wrapperProps = getWrapperProps({checkElementType, isDisabled, isSelected, onChange: handleChange})

  const baseClassNames = cx(BASE_CLASS, design && `${BASE_CLASS}--${design}`, {
    [`${BASE_CLASS}--fullWidth`]: isFullWidth,
    [`${BASE_CLASS}--highlighted`]: isHighlighted || isSelected,
    [`${BASE_CLASS}--selected`]: isSelected,
    [`${BASE_CLASS}--paddingLess`]: paddingLess,
    [`${BASE_CLASS}--disabled`]: isDisabled
  })

  return (
    <PolymorphicElement className={baseClassNames} {...wrapperProps}>
      <Injector
        attributes={attributes}
        checkElementType={checkElementType}
        description={description}
        design={design}
        direction={direction}
        element={element}
        extendedInfo={extendedInfo}
        hasIconCheck={hasIconCheck}
        helpText={helpText}
        icon={icon}
        id={id}
        imageSrc={imageSrc}
        isBolder={isBolder}
        isFullWidth={isFullWidth}
        isHighlighted={isHighlighted}
        isIndeterminate={isIndeterminate}
        isLeftIcon={isLeftIcon}
        isSelected={isSelected}
        label={label}
        onChange={handleChange}
        rightIcon={rightIcon}
        showCheckOnSelected={showCheckOnSelected}
        tabIndex={tabIndex}
      >
        <ItemBasicContent />
      </Injector>
    </PolymorphicElement>
  )
}

FilterItemBasic.displayName = 'FilterItemBasic'
FilterItemBasic.propTypes = {
  attributes: PropTypes.arrayOf(PropTypes.shape({key: PropTypes.string, value: PropTypes.string})),
  checkElementType: PropTypes.string,
  description: PropTypes.string,
  design: PropTypes.string,
  direction: PropTypes.string,
  element: PropTypes.node,
  extendedInfo: PropTypes.string,
  hasIconCheck: PropTypes.bool,
  helpText: PropTypes.string,
  icon: PropTypes.func,
  id: PropTypes.string.isRequired,
  imageSrc: PropTypes.string,
  isBolder: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  isHighlighted: PropTypes.bool,
  isIndeterminate: PropTypes.bool,
  isLeftIcon: PropTypes.bool,
  isSelected: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  paddingLess: PropTypes.bool,
  rightIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  showCheckOnSelected: PropTypes.bool,
  tabIndex: PropTypes.number,
  type: PropTypes.string
}

export {
  CHECK_ELEMENT_TYPES as filterItemBasicCheckElementTypes,
  DESIGNS as filterItemBasicDesigns,
  DIRECTIONS as filterItemBasicDirections
}

export default FilterItemBasic
